import React from 'react';
import PlacementTestReportFilter from './PlacementTestReportFilter';
import placementTestReportFilterService from '../services/PlacementTestReportFilterService';
import { observer } from 'mobx-react';

class PlacementTestReportFilterContainer extends React.Component {
  componentDidMount() {
    placementTestReportFilterService.init();
  }

  render() {
    return (
      <PlacementTestReportFilter
        onChange={placementTestReportFilterService.form.setValue}
        values={placementTestReportFilterService.form.getValues()}
        onSearch={placementTestReportFilterService.handleSearch}
      />
    );
  }
}

export default observer(PlacementTestReportFilterContainer);
